import { Trash2 } from 'lucide-react';
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import useApiRequest from '../../../lib/hooks/useRequest';
import { CustomerInvitationListResponseDto } from '../../../lib/interfaces/customers/users';
import { Paginated } from '../../../lib/interfaces/utils';
import { Button } from '../../../ui/components/ui/button';

const OrganisationInvitationsList = ({ organisationId, setReload }: { organisationId: string; setReload: Dispatch<SetStateAction<boolean>> }) => {
  const { apiRequest } = useApiRequest();
  const [invitations, setInvitations] = useState<CustomerInvitationListResponseDto[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchInvitations = useCallback(async () => {
    setLoading(true);
    const res = await apiRequest<Paginated<CustomerInvitationListResponseDto>>(
      `organizations/internal/${organisationId}/invitations?limit=20&page=1`,
      'GET'
    );
    setLoading(false);
    if (res.data?.docs) {
      setInvitations(res.data.docs);
    }
  }, [apiRequest, organisationId]);

  useEffect(() => {
    fetchInvitations();
  }, [fetchInvitations]);

  const abortInvitation = async (invitationId: string) => {
    await apiRequest(`organizations/internal/${organisationId}/invitations/${invitationId}`, 'DELETE', {
      toast: { toastText: 'Einladung wurde zurückgezogen' }
    });
    setReload((prev) => !prev);
    fetchInvitations();
  };

  if (loading) {
    return <div className="text-sm text-[#888] py-2">Einladungen werden geladen…</div>;
  }

  if (invitations.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2 pt-4 mt-4">
      <p className="text-[16px] font-bold text-[#12282A]">Offene Einladungen</p>
      <ul className="flex flex-col gap-2">
        {invitations.map((inv) => (
          <li key={inv._id} className="flex items-center justify-between gap-2 py-2 px-3 bg-gray-50 rounded-lg text-sm">
            <span className="text-[#12282A]">
              {inv.firstName} {inv.lastName}
            </span>
            <span className="text-[#888] truncate flex-1 min-w-0 mx-2">{inv.mail}</span>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="text-red-500 hover:text-red-600 shrink-0"
              onClick={() => abortInvitation(inv._id)}>
              <Trash2 size={16} />
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OrganisationInvitationsList;
